import React from 'react';
import { Masthead } from '../components/Masthead';
import { Navigation } from '../components/Navigation';
import { FeaturedStory } from '../components/FeaturedStory';
import { SectionPreview } from '../components/SectionPreview';
import { Sidebar } from '../components/Sidebar';
// Mock Data
const southAsiaStories = [{
  id: 'sa1',
  title: 'Monsoon Season Brings Record Rainfall to Coastal Regions',
  excerpt: 'Meteorological departments across the subcontinent report unprecedented precipitation levels, raising concerns for agricultural yields.',
  author: 'Priya Sharma',
  timestamp: '2h ago',
  imageUrl: 'https://images.unsplash.com/photo-1519692933481-e162a57d6721?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 'sa2',
  title: 'New Trade Agreement Signed Between Regional Powers',
  excerpt: 'Economic cooperation reaches new heights as historic deal is finalized in New Delhi summit.',
  author: 'Rahul Verma',
  timestamp: '5h ago',
  imageUrl: 'https://images.unsplash.com/photo-1526304640152-d4619684e484?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 'sa3',
  title: 'Cultural Heritage Sites Receive UNESCO Funding',
  excerpt: 'Ancient temples and monuments slated for restoration under new international preservation grant.',
  author: 'Amara Singh',
  timestamp: '8h ago',
  imageUrl: 'https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=2076&auto=format&fit=crop'
}];
const financialStories = [{
  id: 'fin1',
  title: 'Tech Sector Volatility Continues Amid AI Regulation Talks',
  excerpt: 'Investors remain cautious as lawmakers debate the framework for artificial intelligence governance.',
  author: 'James Wilson',
  timestamp: '1h ago',
  imageUrl: 'https://images.unsplash.com/photo-1611974765270-ca1258634369?q=80&w=2064&auto=format&fit=crop'
}, {
  id: 'fin2',
  title: 'Oil Prices Stabilize After Week of Fluctuations',
  excerpt: 'OPEC+ meeting concludes with decision to maintain current production levels through Q3.',
  author: 'Maria Gonzalez',
  timestamp: '3h ago',
  imageUrl: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?q=80&w=1974&auto=format&fit=crop'
}, {
  id: 'fin3',
  title: 'Cryptocurrency Markets See Renewed Institutional Interest',
  excerpt: 'Major banks announce pilot programs for blockchain-based settlement systems.',
  author: 'David Chen',
  timestamp: '6h ago',
  imageUrl: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=2069&auto=format&fit=crop'
}];
const lifestyleStories = [{
  id: 'life1',
  title: 'The Return of Slow Travel: Why Trains are Back in Vogue',
  excerpt: 'Travelers are trading airport queues for scenic rail routes as sustainability becomes a priority.',
  author: 'Sophie Laurent',
  timestamp: '4h ago',
  imageUrl: 'https://images.unsplash.com/photo-1474487548417-781cb71495f3?q=80&w=2184&auto=format&fit=crop'
}, {
  id: 'life2',
  title: 'Culinary Heritage: Reviving Forgotten Grains',
  excerpt: 'Chefs are looking to the past to create a more sustainable and nutritious future for fine dining.',
  author: 'Marco Rossi',
  timestamp: '7h ago',
  imageUrl: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?q=80&w=2080&auto=format&fit=crop'
}, {
  id: 'life3',
  title: 'Modern Minimalism in Victorian Architecture',
  excerpt: 'How interior designers are blending contemporary aesthetics with historic structural charm.',
  author: 'Eleanor Rigby',
  timestamp: '12h ago',
  imageUrl: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=1974&auto=format&fit=crop'
}];
export function HomePage() {
  return <div className="min-h-screen bg-paper flex flex-col" data-id="element-121">
      <Masthead data-id="element-122" />
      <Navigation data-id="element-123" />

      <main className="flex-grow max-w-7xl mx-auto w-full px-4 py-8 md:py-12" data-id="element-124">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-125">
          {/* Main Content Column */}
          <div className="lg:col-span-8" data-id="element-126">
            <FeaturedStory data-id="element-127" />

            <div className="space-y-12" data-id="element-128">
              <SectionPreview title="South Asia" stories={southAsiaStories} data-id="element-129" />
              <SectionPreview title="Financial Markets" stories={financialStories} data-id="element-130" />
              <SectionPreview title="Lifestyle & Culture" stories={lifestyleStories} data-id="element-131" />
            </div>
          </div>

          {/* Sidebar Column */}
          <div className="lg:col-span-4 border-l border-gray-200 pl-0 lg:pl-8" data-id="element-132">
            <Sidebar data-id="element-133" />
          </div>
        </div>
      </main>

      <footer className="bg-ink text-paper py-12 mt-12 border-t-8 border-accent" data-id="element-134">
        <div className="max-w-7xl mx-auto px-4" data-id="element-135">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-136">
            <div className="col-span-1 md:col-span-1" data-id="element-137">
              <h2 className="font-serif text-2xl font-bold mb-4" data-id="element-138">LexisVox</h2>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-139">
                Delivering truth and perspective since 1886. Independent
                journalism for a complex world.
              </p>
            </div>
            <div data-id="element-140">
              <h3 className="font-bold uppercase tracking-widest text-sm mb-4 text-gray-400" data-id="element-141">
                Sections
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-142">
                <li data-id="element-143">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-144">
                    World News
                  </a>
                </li>
                <li data-id="element-145">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-146">
                    Business
                  </a>
                </li>
                <li data-id="element-147">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-148">
                    Technology
                  </a>
                </li>
                <li data-id="element-149">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-150">
                    Arts & Culture
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-151">
              <h3 className="font-bold uppercase tracking-widest text-sm mb-4 text-gray-400" data-id="element-152">
                Support
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-153">
                <li data-id="element-154">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-155">
                    Subscribe
                  </a>
                </li>
                <li data-id="element-156">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-157">
                    Gift Subscriptions
                  </a>
                </li>
                <li data-id="element-158">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-159">
                    Help Center
                  </a>
                </li>
                <li data-id="element-160">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-161">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-162">
              <h3 className="font-bold uppercase tracking-widest text-sm mb-4 text-gray-400" data-id="element-163">
                Legal
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-164">
                <li data-id="element-165">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-166">
                    Terms of Service
                  </a>
                </li>
                <li data-id="element-167">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-168">
                    Privacy Policy
                  </a>
                </li>
                <li data-id="element-169">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-170">
                    Cookie Policy
                  </a>
                </li>
                <li data-id="element-171">
                  <a href="#" className="hover:text-white hover:underline" data-id="element-172">
                    Accessibility
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 font-sans" data-id="element-173">
            <p data-id="element-174">&copy; 2025 LexisVox Media Group. All rights reserved.</p>
            <p className="mt-2 md:mt-0" data-id="element-175">
              Printed in London • New York • Singapore
            </p>
          </div>
        </div>
      </footer>
    </div>;
}